import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';

export class WorkflowSearchResultDto {
    managementCompany: string;
    managementCompanyId: number;
    communityId: number;
    community: string;
    location: string;
    workFlowId: number;
    workFlowName: string;
    workOrders: string;
    invoiceNumber: string;

    @Type(() => Date)
    invoiceDate: Date;

    @Type(() => Date)
    datePosted: Date;
    invoiceAmount: number;
    workflowStatus: string;
    payee: string;
    // value will be based on payeeType the code will have vendorId || CommunityId || RNumber
    payeeId: string;
    payeeCode: string;
    payeeType: string;
    paymentStatus: string;
    accountNumber: string;

    @Type(() => UserNameDisplayResultDto)
    dashboardResponsibleUsers: Array<UserNameDisplayResultDto>;
    dashboardStatus: string;

    @Type(() => Date)
    inboxDate: Date;
    specialHandling: string;

    @Type(() => Date)
    dueDate: Date;

    @Type(() => Date)
    startDate: Date;

    eft: boolean;
    invoiceStatus: string;
    hasNotes: boolean;
    hasBoardNotes: boolean;
    hasBoardApproval: boolean;

    @Type(() => Date)
    communityTerminationDate: Date;

    allowManageWorkOrders: boolean;
    allowInvoiceApproval: boolean;
    allowReverseAPBill: boolean;
    allowReturnToAccountant: boolean;
    allowToggleEFTPayment: boolean;
    allowChangeSpecialHandling: boolean;
    allowProcessing: boolean;
    allowAttributeCommunity: boolean;

    @Type(() => UserNameDisplayResultDto)
    addedBy: UserNameDisplayResultDto;
    addedByCam: boolean;
    vendorType: string;
    // transient
    actionItems: any;

    get dashboardResponsibleUsersDisplayText(): string {
        return !!this.dashboardResponsibleUsers
            ? this.dashboardResponsibleUsers.map((r) => r.displayName).join(', ')
            : '';
    }

    get addedByUsersDisplayText(): string {
        return Utils.notNullAndDefined(this.addedBy) ? this.addedBy.displayName : null;
    }

    get workOrderIds(): Array<string> {
        return Utils.notNullAndDefined(this.workOrders) ? this.workOrders.split(',') : [];
    }
}
